/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Care Club API - ASP.NET 8 - DEVELOPMENT (Local)
 * The Care Club API is a comprehensive backend service developed using ASP.NET 8. It facilitates seamless data access and interaction for services requiring information from the Care Club system. This API is designed to provide secure, reliable, and efficient access to member and service data, ensuring that all dependent applications can operate smoothly.
 * OpenAPI spec version: v1
 */

/**
 * Enum for Property Building Types<p>Members:</p><ul><li><i>detached</i> - A detached building, not connected to any other building.</li><li><i>terraced</i> - A terraced building, typically one in a row of similar houses connected by shared walls.</li><li><i>maisonette</i> - A maisonette, a self-contained apartment (usually on two levels) in a larger house.</li><li><i>flat</i> - A flat, an individual unit in a multi-unit building.</li><li><i>bungalow</i> - A bungalow, a typically single-story building.</li></ul><p>Members:</p><ul></ul>
 */
export type CCNewAPIDtoPropertyBuildingTypeEnum = typeof CCNewAPIDtoPropertyBuildingTypeEnum[keyof typeof CCNewAPIDtoPropertyBuildingTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CCNewAPIDtoPropertyBuildingTypeEnum = {
  detached: 'detached',
  semi_detached: 'semi_detached',
  terraced: 'terraced',
  maisonette: 'maisonette',
  flat: 'flat',
  bungalow: 'bungalow',
} as const;
